export type PerformanceMode = "low" | "medium" | "high"

export interface PerformancePreset {
  cacheLimit: number
  prefetchAmount: number
  gridColumns: number
  imageQuality: "preview" | "sample" | "full"
  infiniteScroll: boolean
  autoplayVideos: boolean
}

export const performancePresets: Record<PerformanceMode, PerformancePreset> = {
  low: {
    cacheLimit: 20,
    prefetchAmount: 2,
    gridColumns: 2,
    imageQuality: "preview",
    infiniteScroll: false,
    autoplayVideos: false,
  },
  medium: {
    cacheLimit: 100,
    prefetchAmount: 5,
    gridColumns: 4,
    imageQuality: "sample",
    infiniteScroll: true,
    autoplayVideos: false,
  },
  high: {
    cacheLimit: 300,
    prefetchAmount: 15,
    gridColumns: 6,
    imageQuality: "full",
    infiniteScroll: true,
    autoplayVideos: true,
  },
}
